import { Mentions } from "antd";
import { getFullName } from "../../../utils/shared";

export const MentionInput = ({
  users = [],
  disabled,
  autoSize = { minRows: 2, maxRows: 5 },
  placeholder = "Write a comment... use @ to mention someone",
  ...extraProps
}) => {
  return (
    <Mentions
      {...extraProps}
      autoSize={autoSize}
      disabled={disabled}
      prefix="@"
      placeholder={placeholder}
      options={[
        ...users.map((u) => ({
          value: getFullName(u),
          label: getFullName(u),
        })),
      ]}
    />
  );
};
